/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, ReactElement } from 'react';
import { Checkbox } from 'src/domains/common/components/checkbox/checkbox';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

interface CheckboxWithStatePropsType extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    dataTest?: string;
    formInputState: FormInputState<boolean, boolean>;
    description?: string;
    errors: string[];
}

export const CheckboxWithState: FC<CheckboxWithStatePropsType> = observer(
    'CheckboxWithState',
    ({ label, formInputState, description, dataTest, disabled, errors, onChange, ...props }): ReactElement => {
        const error = errors.length === 0 ? null : errors[0] ?? null;
        const checked = formInputState.value;

        return (
            <div className='flex flex-col flex-auto gap-2'>
                <Checkbox
                    checked={checked}
                    label={label}
                    isDisabled={disabled}
                    className='flex items-center text-sm'
                    onChange={() => {
                        formInputState.setAsVisited();
                        formInputState.setValueOnChange(!checked);
                    }}
                    {...props}
                />
                {description !== undefined && error === null && (
                    <span className='text-sm text-muted-foreground'>{description}</span>
                )}
                {error === null ? null : <span className='text-sm text-destructive'>{error}</span>}
            </div>
        );
    }
);
